import NiceModal from "@ebay/nice-modal-react";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import { Card, ListGroup } from "react-bootstrap";
import ConditionalSpinner from "../../../../components/ConditionalSpinner";
import { ignoreDragEvent } from "../../../../components/dashboard/Dashboard";
import { useGetProjectsQuery } from "../../../../store/api/kinesense";
//import AddProjectModal from "./AddProjectModal";
import ProjectListItem from "./ProjectListItem";
import { useState } from "react";
import { AddProjectModal } from "../../../organisation/components/projects/AddProjectModal";

function ProjectList() {
    const { data: allProjects, isLoading, isUninitialized } = useGetProjectsQuery();
    const hasLoadedProjects = !isLoading && !isUninitialized;
    const [isNewProjectModalVisible, setIsNewProjectModalVisible] = useState(false);

    return (
        <Card as={motion.article} layout>
            <Card.Header as={motion.header} layout>
                <Card.Title as={motion.h5} layout className="m-1">
                    Projects
                </Card.Title>
            </Card.Header>

            <ListGroup className="border-0" variant="flush" as={motion.div} layout {...ignoreDragEvent}>
                <div className="d-flex flex-column h-100 justify-content-between">
                    <div>
                        <ListGroup.Item as={motion.header} layout>
                            <motion.span layout="position" className="m-0 h6">
                                Name
                            </motion.span>
                            <motion.span layout="position" className="m-0 h6">
                                Videos
                            </motion.span>
                            <motion.span layout="position" className="m-0 h6">
                                Created At
                            </motion.span>
                        </ListGroup.Item>

                        <motion.div layoutScroll className="items">
                            <ConditionalSpinner size="sm" isLoading={!hasLoadedProjects}>
                                {allProjects?.map((data) => <ProjectListItem key={data.projectId} data={data} />)}
                            </ConditionalSpinner>
                        </motion.div>
                    </div>

                    <motion.button
                        layout
                        className="my-2 button-with-icon align-self-center fs-6"
                        onClick={() => setIsNewProjectModalVisible(true)}
                    >
                        <motion.span
                            layout
                            className="gap-2 d-flex align-items-center text-truncate"
                            title="Create a new project"
                        >
                            <FontAwesomeIcon icon={faPlusCircle} />
                            <motion.span layout className="text-truncate">
                                New project
                            </motion.span>
                        </motion.span>
                    </motion.button>
                </div>
            </ListGroup>
            <AddProjectModal isVisible={isNewProjectModalVisible} setIsVisible={setIsNewProjectModalVisible} />
        </Card>
    );
}

export default ProjectList;
